import i18n from '@/i18n'
import { EmailTemplateItemResponse, EmailTemplateResponseList } from '@/types/service-response'

export class EmailTemplate {
  private constructor (
    readonly id: number,
    readonly subject: string,
    readonly body: string,
    readonly templateType: number,
    readonly templateName: string,
    readonly groupId: number | undefined,
    readonly groupName: string
  ) {}

  public static createListFromResponse (data: EmailTemplateResponseList): Array<EmailTemplate> {

    return data.map((item: EmailTemplateItemResponse) => {
      let templateName: string = i18n.t('settings.emailSettings.reportTemplate').toString()
      let groupId: number | undefined = undefined
      let groupName: string = ''

      if(item.TemplateType > 1 && item.TemplateType < 8) {
        groupId = 1
        groupName = 'STV Organisation'

        switch (item.TemplateType) {
          case 2:
            templateName = "Info versenden – STV immer";
            break;
          case 3:
            templateName = "Info versenden – STV nach Absprache";
            break;
          case 4:
            templateName = "Info versenden – STV nie";
            break;
          case 5:
            templateName = "Info versenden – STV per Brief";
            break;
          case 6:
            templateName = "Antwort senden – STV immer, STV nach Absprache, STV nie";
            break;
          case 7:
            templateName = "Antwort senden – STV per Brief";
            break;
        }
      }

      return new EmailTemplate(
        item.ID,
        item.Subject,
        item.Body,
        item.TemplateType,
        templateName,
        groupId,
        groupName
      )
    })
  }

  public static create (id: number, subject: string, body: string, templateType: number): EmailTemplate {
    return new EmailTemplate(
      id,
      subject,
      body,
      templateType,
      '',
      undefined,
      ''
    )
  }
}
